import styled from '@emotion/styled'

const MyCreditReportContainer = styled.div`
`

export {
  MyCreditReportContainer
}
